// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guide-featured[data-v-3f89ab16]{container:featured/inline-size;display:grid;gap:32px;grid-template-columns:1fr}@media(min-width:768px){.guide-featured[data-v-3f89ab16]{gap:16px;grid-template-columns:repeat(3,minmax(0,1fr))}}@media(min-width:768px){.guide-featured .featured-guide[data-v-3f89ab16]{grid-column:span 3}}.guide-featured .secondary-guides[data-v-3f89ab16]{padding-bottom:16px;border-bottom:1px solid #657182}", ""]);
// Exports
module.exports = exports;
